import type { SendQueueItem } from "@/interfaces/sendQueueCampaigns";
import { reminderLabel, sendSubLabel } from "@/utils/sendQueueCampaigns-helper";

interface SendTypeCellProps {
  item: SendQueueItem;
}

/**
 * Two-line "Send Type" cell for the Send Queue table (GFG-194, unit U9). Line 1 is the primary
 * label -- `reminderLabel` composes "Reminder (i of N)" for a reminder row and passes every
 * other kind's `sendLabel` through unchanged. Line 2 is the smaller sub-label explaining the
 * trigger/basis. Both come from sendQueue-helper.ts; no string is retyped here.
 */
export default function SendTypeCell({ item }: SendTypeCellProps) {
  return (
    <div>
      <div>{reminderLabel(item)}</div>
      <div style={{ fontSize: 12, color: "var(--color-graphite)", marginTop: 2 }}>
        {sendSubLabel(item)}
      </div>
    </div>
  );
}
